import React from "react";
import { Navigate, useLocation } from "react-router-dom";
import { useAuth } from "../context/AuthContext";

const Loader = () => (
  <div className="min-h-screen bg-[#050506] flex items-center justify-center">
    <div className="w-10 h-10 border-2 border-purple-500/30 border-t-purple-500 rounded-full animate-spin" />
  </div>
);

export const ProtectedRoute = ({ children, role }) => {
  const { user, ready } = useAuth();
  const location = useLocation();

  if (!ready) return <Loader />;
  if (!user)
    return <Navigate to="/login" state={{ from: location.pathname }} replace />;
  if (role && user.role !== role && !(role === "partner" && user.role === "admin"))
    return <Navigate to="/dashboard" replace />;
  return children;
};
